// Helper function for determining the zoom level on the Leaflet map

import { useState, useEffect } from "react";
import { useMap } from "react-leaflet";

export default function useZoomLevel() {
  const map = useMap();
  const [zoom, setZoom] = useState(() => (map ? map.getZoom() : null));

  useEffect(() => {
    if (!map) return;

    setZoom(map.getZoom());

    const handleZoom = () => {
      setZoom(map.getZoom());
    };

    map.on("zoomend", handleZoom);

    return () => {
      map.off("zoomend", handleZoom);
    };
  }, [map]);

  return zoom;
}